<template>
  <DashboardMenu />
  <div class="w-full md:w-4/5 bg-gray-100 p-4 pt-1">
    <Suspense>
      <div>
        <slot />
      </div>

      <template #fallback>
        <SpinningLoader :pending="true" />
      </template>
    </Suspense>
  </div>
</template>
  
<script setup>
import DashboardMenu from './DashboardMenu.vue'
import SpinningLoader from './SpinningLoader.vue';

defineProps({
  title: {
    type: String,
    default: null
  }
})
</script>